import React from "react";

class IconEndCall extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width}
        height={this.props.height}
        fill="none"
        viewBox="0 0 32 32"
      >
        <path
          fill="#fff"
          d="M9.977 22.272c.593-.012 1.143-.315 1.596-.896.431-.546.636-1.224.636-2.12v-1.902c1.002-.364 2.08-.545 3.46-.57 1.671-.024 2.932.146 4.096.558v.375c-.01.678-.01 1.381.033 2.084.086 1.405 1.046 2.459 2.285 2.507 1.51.06 2.846.06 4.086.024 1.476-.048 2.414-1.066 2.511-2.713.043-.703.033-1.417.022-2.108l-.01-.75c0-1.2-.432-2.254-1.305-3.199-.69-.739-1.542-1.357-2.684-1.938-2.35-1.2-4.991-1.841-8.053-1.975a19.532 19.532 0 00-6.823.933c-1.402.448-3.008 1.066-4.463 2.23-.28.217-.593.484-.895.823a4.666 4.666 0 00-.862 1.369c-.345.848-.367 1.72-.335 2.386.011.34.011.666.011 1.005 0 .437 0 .885.033 1.32.086 1.394 1.088 2.508 2.285 2.557 1.51.036 2.997.024 4.376 0zm16.504-2.386c-.097.108-.27.157-.539.157h-3.439c-.064 0-.14 0-.204-.012-.4-.037-.475-.206-.475-.533-.01-.69-.01-1.393 0-2.084v-.387c.011-.909-.301-1.418-1.056-1.745-1.003-.424-2.124-.678-3.536-.775-1.724-.133-3.266-.012-4.71.351-.42.11-.863.243-1.423.46-.604.219-.928.764-.938 1.527v2.399c0 .157-.011.29-.033.387-.043.194-.15.303-.334.34-.064.011-.14.023-.205.023H6.043c-.399 0-.507-.06-.571-.193a1.375 1.375 0 01-.13-.582c-.021-.593-.021-1.175-.021-1.768v-.606c0-.69.248-1.26.819-1.78 1.25-1.176 2.77-1.77 4.226-2.242 2.36-.763 4.85-1.017 7.384-.763 2.317.23 4.29.775 6.036 1.66.873.448 1.585.884 2.221 1.61l.021.025c.41.412.626 1.005.604 1.732-.01.473-.01.945-.01 1.405v.8c-.011.29-.044.484-.14.593z"
        ></path>
      </svg>
    );
  }
}

IconEndCall.defaultProps = {
  width: 22,
  height: 22
}

export default IconEndCall;
